<template>
  <div>
    <v-row>
      <v-col class="mx-auto">
        <v-card flat>
          <v-card-subtitle
            class="oceanblau--text text-h4 text-uppercase"
            v-html="$t('register.form.title')"
          >
          </v-card-subtitle>
          <v-card-text>
            {{ $t("register.form.confirm.finalMessage") }}
          </v-card-text>
        </v-card>

        <!-- continue Button -->
        <v-card-actions>
          <v-row class="mx-auto">
            <v-col cols="auto">
              <v-btn
                elevation="0"
                tile
                class="rafiButton petrol white--text"
                @click="NextStep"
              >
                {{ $t("register.form.confirm.continue") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "confirm-registration",
  methods: {
    NextStep() {
      window.open("https://onboarding.kisme.com", "_blank");
    },
  },
};
</script>
